import React from "react";
import PropTypes from "prop-types";
import "../style.scss";

/**
 * ContentWrap :
 * - Wrapper for HexagonNode Content
 */
export function ContentWrap(props) {
  return <div className="hex_content">{props.children}</div>;
}

ContentWrap.propTypes = {
  /**
   * Child components
   */
  children: PropTypes.array,
};

ContentWrap.defaultProps = {
  className: "",
};
